export interface ITemplates {
  html: string;
  css?: string;
  name: string;
  type: string;
  code: string;
  isDefault: boolean;
  businessUnitId: number;
}
